var map = {
	"./assistant_2.png": 61632,
	"./comparator_2.png": 38636,
	"./heatmap_2.png": 68116,
	"./history_2.png": 22392,
	"./learning_2.png": 36674,
	"./manager_2.png": 261,
	"./nps_2.png": 37661,
	"./report_2.png": 48802,
	"./rps_2.png": 97121,
	"./settings_2.png": 62803,
	"./survey_2.png": 86038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10088;